import { unsafeCSS, html } from "lit";
import { property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { e } from "../../scoped-registry-mixin-2fqf-E5n.js";
import { LeafElement } from "../../components/leaf-element.js";
const styles = ":host .chc-c-product-card__drug-coverage {\n  display: flex;\n  flex-direction: column;\n  row-gap: var(--leaf-spacing-16);\n  background-color: var(--leafdcws-accent-1-subtle);\n  margin-top: var(--leaf-spacing-32);\n  padding: var(--leaf-spacing-24) var(--leaf-spacing-32);\n}\n:host .chc-c-product-card__drug-coverage ::slotted([slot=price]) {\n  font-family: var(--leaf-typography-title-default-font-family) !important;\n  font-size: var(--leaf-typography-title-default-font-size) !important;\n  font-weight: var(--leaf-typography-title-default-font-weight) !important;\n  line-height: var(--leaf-typography-title-default-line-height) !important;\n  -webkit-text-decoration: var(--leaf-typography-title-default-text-decoration) !important;\n          text-decoration: var(--leaf-typography-title-default-text-decoration) !important;\n  text-transform: var(--leaf-typography-title-default-text-transform) !important;\n}\n:host .chc-c-product-card__drug-coverage__link {\n  align-items: center;\n}\n:host .chc-c-product-card__drug-coverage--bg-error {\n  background-color: var(--leaf-color-bg-error);\n}\n:host .chc-c-product-card__drug-coverage a {\n  margin-top: 0;\n  margin-bottom: 0;\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const _CHCProductCardDrugCoverage = class _CHCProductCardDrugCoverage extends e(LeafElement) {
  constructor() {
    super(...arguments);
    this.variant = void 0;
  }
  render() {
    const componentClassName = {
      "chc-c-product-card__drug-coverage": true,
      "chc-c-product-card__drug-coverage__link": this.variant === "link",
      "chc-c-product-card__drug-coverage--bg-error": this.variant === "error"
    };
    return html`<div class=${classMap(componentClassName)}>
      <slot></slot>
      <slot name="price"></slot>
      <slot name="edit-link"></slot>
    </div>`;
  }
};
_CHCProductCardDrugCoverage.styles = unsafeCSS(styles);
let CHCProductCardDrugCoverage = _CHCProductCardDrugCoverage;
__decorateClass([
  property({ reflect: true })
], CHCProductCardDrugCoverage.prototype, "variant", 2);
export {
  CHCProductCardDrugCoverage
};
//# sourceMappingURL=product-card-drug-coverage.component.js.map
